import { useCallback } from 'react';

import { useRequest } from '@Hooks';
import { API } from '@Services';

export const useConfirmFund = () => {
  const [fetch, response] = useRequest<'' | undefined>();

  const confirmFund = useCallback(
    (fundId: number) =>
      fetch(API.paths.funds_confirm(fundId), 'patch', {
        data: null,
      }),
    [fetch],
  );

  return [confirmFund, response] as const;
};
